<template>
  <transition-group name="product" tag="div" class="product-list grid-row">
    <div
      v-for="product in aProduct"
      :key="product.TMOD"
      class="c-3 no-gutter product"
      @click="goToProduct(product)"
    >
      <Product :productinfo="product" />
    </div>
  </transition-group>
</template>

<script>
import Product from "@/modules/produit/components/Product";

import searchService from "@/modules/recherche/services/searchService";

export default {
  props: ["type"],
  components: {
    Product
  },
  data() {
    return {
      aProduct: Array(),
      critere: {
        mostview: {
          ftyp_liste: "V",
          plimit: 4
        },
        favorite: {
          ftyp_liste: "F",
          plimit: 4
        }
      }
    };
  },
  created() {
    if (this.$props.type === "mostview") {
      searchService.getResearch(this.critere.mostview).then(res => {
        this.aProduct = res.data.DS_O.OUT;
      });
    }

    if (this.$props.type === "favorite") {
      searchService.getResearch(this.critere.favorite).then(res => {
        this.aProduct = res.data.DS_O.OUT;
      });
    }
  },
  methods: {
    goToProduct(product) {
      this.$router.push({
        name: "productpage",
        query: {
          p: product.TMOD
        },
        params: {
          sProductLibelle: product.TMOD_DESC
        }
      });
    }
  }
};
</script>
<style scoped>
</style>